module.exports = __webpack_public_path__ + "static/media/empty.30e8d36c.svg";